<template>
  <div style="display: flex">
    <div style="flex-shrink: 0">
      <h1 :style="textStyle">
        {{ formattedText }}
      </h1>
    </div>
  </div>
</template>

<script>
import {
  registerChannelListener,
  removeChannelListener,
} from '@/utils/web-socket'

import http from '../../../utils/http'

export default {
  name: 'ViewShowText',
  props: {
    componente: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sensorValue: null,
      sensorVirtualValue: null,
      expressaoValue: null,
      refToListener: null,
      refToListenerVirtual: null,
    }
  },
  computed: {
    textStyle() {
      return {
        padding: '0.3em',
        color: this.componente.value.color,
        backgroundColor: this.componente.value.backgroundColor,
        fontSize: this.componente.value.fontSize,
        textAlign: this.componente.value.textAlign,
        fontFamily: this.componente.value.fontFamily,
        fontWeight: this.componente.value.fontWeight,
        fontStyle: this.componente.value.fontStyle,
      }
    },
    formattedText() {
      let text = this.componente.value.text

      if (this.componente.value.sensorId !== null) {
        const value =
          this.sensorValue !== null
            ? this.sensorValue.valor.toString()
            : 'Carregando...'
        text = text.replace('$SENSOR', value)
      }

      if (this.componente.value.sensorVirtualId !== null) {
        const value =
          this.sensorVirtualValue !== null
            ? this.sensorVirtualValue.toFixed(2).toString()
            : 'Carregando...'

        text = text.replace('$VIRTUAL', value)
      }

      if (
        this.componente.value.sensorId !== null &&
        this.componente.value.expressao !== ''
      ) {
        const value =
          this.expressaoValue !== null
            ? this.expressaoValue.toString()
            : 'Carregando...'

        text = text.replace('$EXPR', value)
      }

      return text
    },
  },
  async beforeMount() {
    if (this.componente.value.sensorId !== null) {
      this.sensorValue = await http.get(
        `sensor/${this.componente.value.sensorId}/ultima-coleta`
      )
      await this.beginListenSensores()
    }

    if (this.componente.value.sensorVirtualId !== null) {
      await this.updateSensorVirtual(this.componente.value.sensorVirtualId)
      await this.beginListenSensoresVirtuais()
    }

    if (this.canExpressao()) {
      this.loadExpressao()
    }
  },
  beforeDestroy() {
    if (this.refToListener !== null)
      removeChannelListener(
        'view_sensor_id:' + this.componente.value.sensorId,
        'sensor:update_value',
        this.refToListener
      )

    if (this.refToListenerVirtual !== null)
      removeChannelListener(
        'sensor_virtual_id:' + this.componente.value.sensorVirtualId,
        'update_value',
        this.refToListenerVirtual
      )
  },
  methods: {
    async beginListenSensores() {
      this.refToListener = await registerChannelListener(
        'view_sensor_id:' + this.componente.value.sensorId,
        'sensor:update_value',
        (payload) => {
          this.sensorValue = payload
          if (this.canExpressao()) {
            this.loadExpressao()
          }
        }
      )
    },
    async beginListenSensoresVirtuais() {
      this.refToListenerVirtual = await registerChannelListener(
        'sensor_virtual_id:' + this.componente.value.sensorVirtualId,
        'update_value',
        (payload) => {
          this.sensorVirtualValue = payload.result
        }
      )
    },
    async updateSensorVirtual(id) {
      await http.get(`sensor/virtual/${id}/evaluate`).then((e) => {
        this.sensorVirtualValue = e.result
      })
    },
    canExpressao() {
      return (
        this.componente.value.sensorId !== null &&
        this.componente.value.expressao !== ''
      )
    },
    loadExpressao() {
      http
        .post(
          `sensor/${this.componente.value.sensorId}/virtual/evaluate/string`,
          {
            expressao: this.componente.value.expressao,
            tipo: this.componente.value.virtualSensorPeriodoTipo,
            virtualSensorPeriodo: this.componente.value.virtualSensorPeriodo,
          },
          false
        )
        .then((e) => {
          this.expressaoValue = e.result
        })
    },
  },
}
</script>

<style scoped></style>
